import React, { Component, ChangeEvent } from 'react';
import { RouteComponentProps } from 'react-router';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Button, Glyphicon } from 'react-bootstrap'
import ConfigurationStore from '../stores/ConfigurationStore';
import { AllStores } from '../stores';
import { OrganizationFields } from '../components/OrganizationFields';
import { required, isAlpha, isEmail, isAlphanumeric } from '../utils/ValidatorRulesUtils';
import OrganizationStore from '../stores/OrganizationStore';
import { AlertGenerator } from '../components/AlertGenerator';

type OrganizationProps = {
    configurationStore: ConfigurationStore;
}

@inject((allStores: AllStores) => {
    return {
        configurationStore: allStores.configurationStore as ConfigurationStore
    };
})
@observer
class Admin extends Component<OrganizationProps & RouteComponentProps> {

    syncCustomers = () => {
        this.props.configurationStore.syncCustomers();
    };

    syncPolaris = () => {
        this.props.configurationStore.syncPolaris();
    };

    render() {

        const { alertMessage, hideAlert } = this.props.configurationStore;
        return (
            <div>
                <AlertGenerator alertMessage={alertMessage} hideAlert={hideAlert}></AlertGenerator>
                <h1>Admin</h1>
                <Button onClick={this.syncCustomers}>Sync Customers for 2 Way Sms</Button>
                <br />
                <br />
                <Button onClick={this.syncPolaris}>Sync Polaris Config for Patron Renewal</Button>
            </div>
        );
    }
}


export { Admin };